import { render } from "./TheWrapperAccountCreation.vue?vue&type=template&id=0d405cb6&scoped=true"
import script from "./TheWrapperAccountCreation.vue?vue&type=script&lang=js"
export * from "./TheWrapperAccountCreation.vue?vue&type=script&lang=js"

import "./TheWrapperAccountCreation.vue?vue&type=style&index=0&id=0d405cb6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d405cb6"]])

export default __exports__